import React from "react";
import { NavLink } from "react-router-dom";
import Logo from "../Assetss/Logo.png";
import MenuIcon from "./Menuicon"; // 
import Search from "./Search";
import { CONSTANTS_STRINGS } from "../../Utils/Constant";

function HeroSectionII() {
 

  return (
    <div className="relative w-full min-h-screen text-white">
      {/* Fixed Background Image */}
      <div className="fixed top-0 left-0 w-full  h-screen  bg-cover bg-center z-[-1]">
        <img
          src={CONSTANTS_STRINGS?.banner?.img}
          alt="Hero Background"
          className="w-full   h-screen object-cover "
        />
      </div>

      <div className="relative z-10 pb-32 space-y-20">
        {/* Sticky Top Bar */}
        <div className="w-full md:h-24 h-18 sticky top-0 backdrop-blur-sm bg-black/10 bg-opacity-50 flex items-center justify-between px-4 py-2 z-20">
          <img src={Logo} alt="Logo" className="h-10 w-auto" />
          <div className="space-x-5 flex items-center">
            <NavLink
              to="/contact"
              className="bg-[#333752] text-white no-underline hover:bg-[#339966] hidden md:block px-8 py-4 font-bold rounded-full"
            >
              {CONSTANTS_STRINGS?.banner?.contact_button || "Get Your Consult!"}
            </NavLink>
            <Search />
            <div className="hidden sm:block">
              <MenuIcon />
            </div>
          </div>
        </div>

        {/* Scrollable Hero Content */}
        <section className="md:w-2/3 space-y-6 mt-20 md:px-30 px-3">
          <h1 className="text-4xl md:text-7xl font-bold">
            {CONSTANTS_STRINGS?.banner?.title}
          </h1>
          <p className="text-xl">{CONSTANTS_STRINGS?.banner?.description}</p>
          <button className="px-6 py-3 bg-white text-black rounded-full hover:bg-[#339966] transition">
            {CONSTANTS_STRINGS?.banner?.button_text}
          </button>
        </section>
      </div>
    </div>
  );
}

export default HeroSectionII;
